<ng-container>
  <h2 class="sr-only">{{ "EgbpidSuche" | translate }}</h2>

  <form (ngSubmit)="onSubmit()" [meta]="egbpid" #form="ngForm" column-classes="col-md-4,col-md-8">
    <div class="row">
      <div class="col-md-6 col-xs-12">
        <cap-form-control invalidKey="EingabeMussValideEgbpidSein" labelKey="EGBPID">
          <input
            (ngModelChange)="egbpid && egbpid.egbpid && (egbpid.egbpid.value = $event)"
            [ngModel]="egbpid && egbpid.egbpid && egbpid.egbpid.value"
            #EGBPID
            appAutofocus
            id="egbpid.egbpid.value"
            name="egbpid.egbpid.value"
            required
            type="text" />
          @if (loading) {
            <cap-spinner-small style="margin-top: -40px"></cap-spinner-small>
          }
        </cap-form-control>
      </div>
    </div>

    <div class="p-2" id="actionpane">
      <div class="rechtsbuendig">
        <button (click)="onReset(EGBPID)" class="btn btn-outline-primary btn-actionpane" type="button">
          {{ "Zurücksetzen" | translate }}
        </button>
        <button [disabled]="loading || form.invalid" class="btn btn-primary btn-actionpane" type="submit">
          {{ "Suche" | translate }}
        </button>
      </div>
    </div>
  </form>
</ng-container>
